<app-question-card>
  <p question>
    <ng-container *ngIf="leadType === AgentLeadType.HV && !formConfig.settings?.includeSellingTimeline; else IO">
      One more step before you view your report.
    </ng-container>
    <ng-template #IO> Let’s verify owner information.</ng-template>
  </p>

  <form input-options #loginForm="ngForm">
    <!--    <div class="box-c mb-20" *ngIf="journeyType === FelloOfferJourneyType.IO; else LwfBox">-->
    <!--      <p>Please provide your phone number so that we can reach out to you once your offer is ready.</p>-->
    <!--    </div>-->

    <!--    <ng-template #LwfBox>-->
    <!--      <div class="box-c mb-20">-->
    <!--        <p>-->
    <!--          We need your phone number so that your matched Fello partner agent can reach out to you for discussing the next steps for selling-->
    <!--          your home.-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </ng-template>-->
    <div class="flex-box">
      <div class="form-field mb-3">
        <label class="mb-1 d-block"
          >First Name <span class="fw-400" *ngIf="!formConfig.settings.firstNameMandatory">(Optional)</span></label
        >
        <input
          type="text"
          placeholder="First Name"
          [required]="formConfig.settings.firstNameMandatory"
          [(ngModel)]="firstName"
          [minlength]="2"
          [maxLength]="64"
          #firstNameInputField="ngModel"
          (keyup.enter)="firstName.length > 1 && lastNameInput.focus()"
          name="firstName"
        />
      </div>
      <div class="form-field mb-3 ml-3">
        <label class="mb-1 d-block">Last Name <span class="fw-400" *ngIf="!formConfig.settings.lastNameMandatory">(Optional)</span></label>
        <input
          type="text"
          placeholder="Last Name"
          [(ngModel)]="lastName"
          [maxLength]="64"
          [minlength]="1"
          #lastNameInputField="ngModel"
          [required]="formConfig.settings.lastNameMandatory"
          #lastNameInput
          (keyup.enter)="lastName.length > 0 && loginForm?.valid && next()"
          name="lastName"
        />
      </div>
    </div>

    <div class="form-field">
      <label class="mb-1 d-block">
        Phone
        <span class="fw-400" *ngIf="!formConfig.settings.phoneMandatory">(Optional)</span>
      </label>
      <input
        type="tel"
        placeholder="Phone number"
        name="phone"
        libFormatPhone
        [required]="formConfig.settings.phoneMandatory"
        [pattern]="phoneNumberPattern"
        (keyup.enter)="loginForm?.valid && next()"
        [(ngModel)]="userPhone"
      />
    </div>

    <!-- <p class="text-size-12 mt-20">*By clicking “Continue” I agree to Fello’s Terms of Use, Privacy Policy, and Consent to Contact Customer. You can contact Fello at 1-866-793-0051 to opt out of electronic communication.</p> -->
  </form>

  <p class="chat-answer" answer>
    {{ firstName }} {{ lastName }}<br />
    {{ userPhone }}
  </p>

  <button class="w-100 mt-4" input-options (click)="next()" [disabled]="loginForm?.invalid">Continue</button>
  <p input-options class="text-size-14 fw-400 text-color-light mt-4 mb-3" *ngIf="consentText$ | async; let consentText">
    <input class="consent-checkbox mr-1 w-auto" checked disabled type="checkbox" />
    <span dynamicTooltipDirective class="link-underline" [innerHTML]="consentText | safeHtml"></span>
  </p>
  <p class="text-size-14 fw-400 text-color-light mt-4 mb-3" input-options *ngIf="settings$ | async; let settings">
    You also agree to our
    <a target="_blank" [href]="settings.privacyPolicyUrl ?? felloWebsites.PRIVACY_POLICY" class="text-underline text-size-14"
      >Privacy Policy</a
    >, and to our
    <a target="_blank" [href]="settings.termsAndConditionsUrl ?? felloWebsites.TERMS_AND_CONDITIONS" class="text-underline text-size-14"
      >Terms of Service</a
    >.
  </p>
</app-question-card>
